import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './close-button.styl'

export default class CloseButton extends Component {
  static propTypes = {
    onClick: PropTypes.func
  }

  render() {
    return (
      <i className={`ico ico--close ${styles.close}`} onClick={this.props.onClick} />
    )
  }
}
